module.exports = __webpack_public_path__ + "img/logo.f7f41ae3.jpg";